export default __webpack_public_path__ + "video-img.4b99fb.jpg";